import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { buildTableFilterParams } from '@ics-portal/ics-data-table';
import { Route } from '@constants/routes';
import { type StringOption } from '@models/Option';

interface NotificationListProps {
    notifications: StringOption[];
}

export function NotificationsList({
    notifications,
}: NotificationListProps): ReactNode {
    if (!notifications.length) {
        return <p>No notifications found</p>;
    }

    return (
        <ul className="m-0 pl-4">
            {notifications.map((notification) => (
                <li key={notification.value}>
                    <Link
                        to={`${Route.SecurityNotifications}?${buildTableFilterParams(
                            'global-security-notifications',
                            [
                                {
                                    key: 'title',
                                    operator: 'contains',
                                    value: notification.label,
                                },
                            ],
                        ).toString()}`}
                    >
                        {notification.label}
                    </Link>
                </li>
            ))}
        </ul>
    );
}
